"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasLauTownDistricts = void 0;
/*if there should be labels 'mestska cast' or 'katastralni_uzemi'*/
const hasLauTownDistricts = (lau) => {
    return lau?.id === 554782; //Praha
};
exports.hasLauTownDistricts = hasLauTownDistricts;
